import React, { ReactElement } from 'react';
import { LinkedIn } from '@material-ui/icons';
import { Typography, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import logoImg from '../../images/logo-new.png';
import upgetgo from './upgetgo-logo.png';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: '1rem 0',
        display: 'flex',
        justifyContent: 'space-between',
    },
    title: {
        fontWeight: 'bold',
    },
    socialIcon: {
        color: 'black',
        width: 40,
        height: 40,
        cursor: 'pointer',
    },
    copyrightText: {
        marginTop: '0.8rem',
    },
    titleContainer: {
        textDecoration: 'none',
        color: 'inherit',
        display: 'flex',
        alignItems: 'center',
        [`& img`]: {
            width: 150,
            marginRight: '1rem',
        },
        [`&:hover`]: {
            textDecoration: 'underline',
        },
    },
    address: {
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    right: {
        display: 'flex',
        alignItems: 'center',
    },
    upgetgo: {
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: '#333',
        marginLeft: 10,
        [`& img`]: {
            marginLeft: 10,
            width: 30,
        },
        [`&:hover`]: {
            color: '#666',
        },
    },
}));

function Footer(): ReactElement {
    const classes = useStyles();
    const linkedInUrl = 'https://www.linkedin.com/company/69522614';
    return (
        <div className={classes.root}>
            <Link className={classes.titleContainer} to="/">
                <img src={logoImg} alt="London Insulation Services" />
            </Link>
            <Typography className={classes.address} color="textPrimary" variant="subtitle1">
                50 The Broadway, Leigh-on-sea
                <br />
                Essex, EC3R 6HD
            </Typography>
            <div className={classes.right}>
                <LinkedIn
                    onClick={(): null | Window => window.open(linkedInUrl, '_blank')}
                    className={classes.socialIcon}
                />
                <a target="_blank" rel="noopener noreferrer" href="https://upgetgo.com" className={classes.upgetgo}>
                    <Typography variant="subtitle2" color="inherit">
                        Website Designed by UpGetGo
                    </Typography>
                    <img src={upgetgo} alt="UpGetGo Web design" />
                </a>
            </div>
        </div>
    );
}

export default Footer;
